/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopItem = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The WorkshopItem model module.
   * @module model/WorkshopItem
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>WorkshopItem</code>.
   * @alias module:model/WorkshopItem
   * @class
   */
  var exports = function() {
    var _this = this;
















  };

  /**
   * Constructs a <code>WorkshopItem</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WorkshopItem} obj Optional instance to populate.
   * @return {module:model/WorkshopItem} The populated <code>WorkshopItem</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('CategoryID')) {
        obj['CategoryID'] = ApiClient.convertToType(data['CategoryID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('MergedToItemID')) {
        obj['MergedToItemID'] = ApiClient.convertToType(data['MergedToItemID'], 'Integer');
      }
      if (data.hasOwnProperty('FromCrossPollinationItemID')) {
        obj['FromCrossPollinationItemID'] = ApiClient.convertToType(data['FromCrossPollinationItemID'], 'Integer');
      }
      if (data.hasOwnProperty('ToCrossPollinationItemID')) {
        obj['ToCrossPollinationItemID'] = ApiClient.convertToType(data['ToCrossPollinationItemID'], 'Integer');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('ParticipantID')) {
        obj['ParticipantID'] = ApiClient.convertToType(data['ParticipantID'], 'Integer');
      }
      if (data.hasOwnProperty('SubcategoryID')) {
        obj['SubcategoryID'] = ApiClient.convertToType(data['SubcategoryID'], 'Integer');
      }
      if (data.hasOwnProperty('Updated')) {
        obj['Updated'] = ApiClient.convertToType(data['Updated'], 'Date');
      }
      if (data.hasOwnProperty('UpdatedBy')) {
        obj['UpdatedBy'] = ApiClient.convertToType(data['UpdatedBy'], 'Integer');
      }
      if (data.hasOwnProperty('WidgetID')) {
        obj['WidgetID'] = ApiClient.convertToType(data['WidgetID'], 'Integer');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} CategoryID
   */
  exports.prototype['CategoryID'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Integer} MergedToItemID
   */
  exports.prototype['MergedToItemID'] = undefined;
  /**
   * @member {Integer} FromCrossPollinationItemID
   */
  exports.prototype['FromCrossPollinationItemID'] = undefined;
  /**
   * @member {Integer} ToCrossPollinationItemID
   */
  exports.prototype['ToCrossPollinationItemID'] = undefined;
  /**
   * @member {Integer} Sort
   */
  exports.prototype['Sort'] = undefined;
  /**
   * @member {Integer} ParticipantID
   */
  exports.prototype['ParticipantID'] = undefined;
  /**
   * @member {Integer} SubcategoryID
   */
  exports.prototype['SubcategoryID'] = undefined;
  /**
   * @member {Date} Updated
   */
  exports.prototype['Updated'] = undefined;
  /**
   * @member {Integer} UpdatedBy
   * @default 0
   */
  exports.prototype['UpdatedBy'] = 0;
  /**
   * @member {Integer} WidgetID
   * @default 0
   */
  exports.prototype['WidgetID'] = 0;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


